import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
import Icon from '../common/containers/icon';
import { DONE_BUTTON_LABEL } from './feedbackCopy';
const FeedbackConfirmation = ({
  note: _note = '',
  onDone
}) => /*#__PURE__*/React.createElement("div", {
  className: "t-feedback-confirmation"
}, /*#__PURE__*/React.createElement("span", {
  className: "t-feedback-confirmation__icon",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement(Icon, {
  glyph: "check-circle"
})), _note ? /*#__PURE__*/React.createElement("p", {
  className: "t-feedback-confirmation__note"
}, _note) : null, /*#__PURE__*/React.createElement(Button, {
  type: "button",
  color: "primary",
  onClick: onDone
}, DONE_BUTTON_LABEL));
FeedbackConfirmation.propTypes = {
  note: PropTypes.string,
  onDone: PropTypes.func.isRequired
};
export default FeedbackConfirmation;